import { WorkbenchTheme } from '../../shared/themes';

export type SpinnerTheme = WorkbenchTheme | 'blue';
export const DEFAULT_SPINNER_THEME: SpinnerTheme = 'light';
